import { Box } from "@chakra-ui/react"
import React from "react"

export const TestersOnboardingContainer: React.FC<
  React.PropsWithChildren<unknown>
> = (props) => {
  return <Box maxW="2xl" mx="auto" mt={28} mb={15} {...props} />
}
